module.exports = __webpack_public_path__ + "static/img/1061_big.fea6f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1061_big.png
// module id = k2LV
// module chunks = 1